import { SERVICE_IMG } from "../campaigns";
import { PROJECTS } from "./projects";

// WHAT WE DO services. `match` lists the project tags that belong to each
// service, so service pages assemble their galleries automatically.
export const SERVICES = [
  {
    slug: "projection-advertising",
    title: "Projection Advertising",
    desc: "High impact campaigns that place your brand on the world's most iconic surfaces.",
    intro: "We turn architecture into a canvas for light, transforming familiar spaces into striking pieces of visual art. Through large-scale projection, creative content and precise technical execution, we bring brands into the physical world in ways that feel unexpected, immersive and impossible to ignore. For us, projection advertising is where art, architecture and technology meet.",
    img: SERVICE_IMG.advertising,
    match: ["Projection Advertising"],
  },
  {
    slug: "architectural-mapping",
    title: "Architectural Mapping",
    desc: "Transforming buildings and environments into immersive visual stories.",
    intro: "Every building has its own character, structure and story. Architectural mapping allows us to reinterpret that structure through light, turning facades into living canvases of colour, movement and visual storytelling. We combine artistic direction with precise mapping technology to create experiences that make architecture feel completely new.",
    img: SERVICE_IMG.mapping,
    match: ["Architectural Mapping", "Projection Mapping"],
  },
  {
    slug: "immersive-experiences",
    title: "Immersive Experiences",
    desc: "Interactive installations and experiential spaces that engage and inspire.",
    intro: "At Luminart, light is a creative medium. We use projection, movement, sound, space and technology to create environments that people don't simply look at, but step into and experience. From intimate installations to large-scale brand experiences, our work is about creating moments where art and technology come together to transform the way a space feels.",
    img: SERVICE_IMG.immersive,
    match: ["Immersive"],
  },
  {
    slug: "live-events",
    title: "Live Events",
    desc: "Visual production and content for concerts, festivals, launches and live shows.",
    intro: "Light has the power to change the energy of a room, a stage or an entire crowd. We create visual experiences for live events that combine art, technology and precise production, from concerts and launches to festivals and live shows. Behind every striking visual is a carefully engineered system designed to perform seamlessly when it matters most.",
    img: SERVICE_IMG.live,
    match: ["Live Event"],
  },
  {
    slug: "installations",
    title: "Installations",
    desc: "Temporary or permanent installations for venues, retail, hospitality and private spaces.",
    intro: "We create art with light that becomes part of the space itself. From private villas and hospitality environments to retail and permanent installations, we design visual experiences that can live within an environment long after an event is over. Our installations bring together architecture, technology and artistic expression to create spaces that feel distinctive, atmospheric and alive.",
    img: SERVICE_IMG.installations,
    match: ["Installation"],
  },
];

// Service-slug → project category matching (used by service pages).
export const SERVICE_MATCH = {
  "projection-advertising": ["Projection Advertising"],
  "architectural-mapping": ["Architectural Mapping", "Projection Mapping"],
  "immersive-experiences": ["Immersive"],
  "live-events": ["Live Event"],
  installations: ["Installation"],
};

export const projectsForService = (service, projects = PROJECTS) => {
  const match = SERVICE_MATCH[service.slug] || [service.title];
  return projects.filter((p) =>
    p.tags.some((t) => match.some((m) => t.includes(m)))
  );
};
